import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';
const StyledComponent = styled<any, any>('div', 'labelWrapper', 'autocomplete')`
    ${propStyles};
`;
StyledComponent.defaultProps = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    fontSize: 'xs',
    fontFamily: 'body',
    fontWeight: 'normal',
    color: 'body',
};
export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Autocomplete/StyledComponents/LabelWrapper.tsx